export enum SideNavMode {
  over,
  side,
  push
}
